import { createTranslationMap } from '../../i18n';

import ru from './ru';
import en from './en';

export const translationMap: { ui: typeof ru } = createTranslationMap({ ui: ru });

export { ru, en };